module.exports = __webpack_public_path__ + "static/dashboard_intro1@2x-9b9506a6c009e44cce88c0b895de0f29.png";